import React from "react";

const TextArea = React.forwardRef(
  ({ label, id, name, charCount, maxLength, errormessage, helperText, optional, ...props }, ref) => {
    const hasError = !!errormessage;
    return (
      <div>
        <label
          htmlFor={name}
          className="block text-sm/6 font-medium text-ink-700"
        >
          {label}
          {optional && (
            <span className="ml-1 font-normal text-ink-400">(optional)</span>
          )}
        </label>
        {helperText && (
          <p className="mt-1 text-xs text-ink-500">{helperText}</p>
        )}
        <div className="mt-2">
          <textarea
            id={id}
            name={name}
            ref={ref}
            rows={4}
            className={`block w-full rounded-card bg-white px-3.5 py-2.5 text-base text-ink-900 border placeholder:text-ink-400 placeholder:italic transition-colors duration-150 ease-editorial focus:outline-none focus:ring-2 sm:text-sm sm:leading-6 ${
              hasError
                ? "border-l-4 border-l-signal-red-500 border-y border-r border-ink-200 focus:ring-signal-red-500/20"
                : "border-ink-200 focus:border-accent-500 focus:ring-accent-500/20"
            }`}
            {...props}
          />
        </div>
        {hasError ? (
          <p className="mt-2 text-sm text-signal-red-700">{errormessage}</p>
        ) : null}
        {maxLength != null && charCount != null && (
          <p
            className={`mt-2 text-xs tabular ${
              charCount > maxLength ? "text-signal-red-700" : "text-ink-500"
            }`}
          >
            {charCount} / {maxLength} characters
          </p>
        )}
      </div>
    );
  }
);

export default TextArea;
